import lazyLoad from "@loadable/component";
import createPlugin from "./createPlugin";
import USPBlockRenderer from "./Renderer";

const USPBlockForm = lazyLoad(() => import("./Form"));

const USPBlockPlugin = (settings) =>
    createPlugin({
        Renderer: USPBlockRenderer,
        Controls: USPBlockForm,
        ...settings,
    });

const USPBlock = USPBlockPlugin();
export default USPBlock;

export { USPBlockPlugin, USPBlockRenderer };
